const refreshWards ='refreshWards';
const refreshCustomers ='refreshCustomers';
const refreshLocations ='refreshLocations';
const refreshUsers ='refreshUsers';
const newTransfer ='NewTransfer';
const transferUpdated ='TransferUpdated';
const transferScheduleUpdated ='TransferScheduleUpdated';
const logoutUserActiveSessions ='LogoutUserActiveSessions';
const refreshCallouts ='refreshCallouts';
const newTeammember ='NewTeammember';
export default{
    refreshWards,
    refreshCustomers,
    refreshLocations,
    refreshUsers,
    newTransfer,
    transferUpdated,
    transferScheduleUpdated,
    logoutUserActiveSessions,
    refreshCallouts,
    newTeammember
}